export { SEOTags } from './SEOTags';
